import { useEffect, useState } from 'react';

const STORAGE_KEY = 'atj_cookie_consent';

export default function CookieBanner({ onNavigate }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, 'accepted'); } catch (e) {}
    setVisible(false);
  };

  const decline = () => {
    try { localStorage.setItem(STORAGE_KEY, 'declined'); } catch (e) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite">
      <div className="cookie-text">
        We use cookies for analytics and to show relevant ads via Google AdSense.{' '}
        <button className="link-btn" onClick={() => onNavigate('privacy')}>
          Read our privacy policy
        </button>.
      </div>
      <div className="cookie-actions">
        <button className="btn btn-ghost btn-sm" onClick={decline}>Decline</button>
        <button className="btn btn-primary btn-sm" onClick={accept}>Accept</button>
      </div>
    </div>
  );
}
